import type { TileColor } from '../../../game/boardMVC/TileColor';
import { shuffle } from '../../../utils/array-utils';
import MathUtils from '../../../utils/MathUtils';

export function getRandomStackColors(
  boardColors: TileColor[],
  stackSize: number,
  minColorRepeat: number,
  maxColorRepeat: number,
): TileColor[] {
  const stackColors: TileColor[] = [];
  let shuffledColors: TileColor[] = shuffle(boardColors);

  while (stackColors.length < stackSize) {
    const fillColor = shuffledColors.pop();
    if (!fillColor) return stackColors;

    const fillCount = MathUtils.clamp(
      MathUtils.getRandomValueInRange(minColorRepeat, maxColorRepeat),
      1,
      stackSize - stackColors.length,
    );

    for (let j = 0; j < fillCount; j += 1) {
      stackColors.push(fillColor);
    }

    // re-shuffle colors avoiding repeats
    if (shuffledColors.length === 0 && stackColors.length < stackSize) {
      shuffledColors = shuffle(boardColors);
      if (shuffledColors.length > 1 && shuffledColors[0] === fillColor) {
        shuffledColors.shift();
        shuffledColors.push(fillColor);
      }
    }
  }

  const reRandomize = stackColors.length > 1 && minColorRepeat > 1 && stackColors.at(-1) !== stackColors.at(-2);
  return !reRandomize ? stackColors : getRandomStackColors(boardColors, stackSize, minColorRepeat, maxColorRepeat);
}
